import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import pagesData from "./pagesData";
import { useEffect } from "react";

const Router = () => {
  const sessionAssessmentId = sessionStorage.getItem("assessmentId");
  const userRole = sessionStorage.getItem("user");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const pathname = location.pathname.toLowerCase();

    if (pathname === "/workspace" && userRole && !sessionAssessmentId) {
      navigate("/home");
    } else if (pathname == "/home" && !userRole) {
      navigate("/login");
    } else if (pathname === "/workspace" && !userRole) {
      navigate("/login");
    }
    else if ((pathname == "/login" || pathname == "/") && userRole) {

      navigate("/home");

  }

    const handleBackButton = (event) => {
      event.preventDefault();
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [userRole, sessionAssessmentId, location]);

  return (
    <>
      {pagesData.map((page) => {
        return (
          <Routes>
            <Route
              key={page.title}
              path={`/${page.path}`}
              element={page.element}
            />
          </Routes>
        );
      })}
    </>
  );
};

export default Router;
